import * as React from "react";
import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="26.5" cy="26.5" r="18.5" stroke="#81BC00" stroke-width="2" />
    <path
      d="M27.6651 18.692L24.9516 16L14 26.865L24.9516 37.73L27.6651 35.038L19.4269 26.865L27.6651 18.692Z"
      fill="#E5FEB0"
    />
    <path
      d="M34.5465 16L23.5949 26.865L34.5465 37.73L37.26 35.038L29.0218 26.865L37.26 18.692L34.5465 16Z"
      fill="#E5FEB0"
    />
  </svg>,
  "SlideNextIcon"
);
